<div class="productPrice">
  <ng-container *ngIf="!product?.sold; else productSold">
    <p>
      <span class="productPrice__price productPrice__price--strikeOut" *ngIf="hasPromotionApplied">{{
        product.regularPrice.formatted
      }}</span>
      <span class="productPrice__price" [ngClass]="{'productPrice__price--promo': hasPromotionApplied}">{{
        product.price.formatted
      }}</span>
      <span *ngIf="displayTaxInfo" i18n="@@PRODUCT.DETAILS.TTC">inc. tax</span>
    </p>
    <p
      *ngIf="product?.buyerFees && product.buyerFees[0].cost.cents > 0; else freeAuthentication"
      class="productPrice__buyerFees vc-body3"
      i18n="@@PRODUCT.DETAILS.BUYER_FEES.AMOUNT"
    >
      +{{ product.buyerFees[0].cost.formatted }} Authentication fees
    </p>
  </ng-container>

  <ng-template #productSold>
    <span class="productPrice__sold" i18n="@@PRODUCT.DETAILS.SOLD.PRICE"
      >Sold at {{ product.price.formatted }} on {{ product.soldDate | date: 'longDate':'GMT' }}</span
    >
  </ng-template>

  <ng-template #freeAuthentication>
    <p class="productPrice__buyerFees vc-body3" i18n="@@PRODUCT.DETAILS.BUYER_FEES.FREE">
      <b>Free</b> Authentication fee
    </p>
  </ng-template>
</div>
